/* @ngInject */
export class PanelController {
  /* @ngInject */
  constructor ($scope, $q) {
    this.$scope = $scope
    this.$q = $q
  }

  $onInit() {

    console.log('PanelController : init')

    if (typeof(this) == "undefined") {
        return;
    }
    this.isOpen = true
    this.selected = false
    if (typeof(this.strtitle) !== "undefined") {
        if (this.strtitle.length == 0) {
          this.strtitle = "terrassor"
        }
        this.hash = this.$q.resolve(hash(this.strtitle))
        }
      else {
          this.hash = "terrassor"
      }

    this.parentPanel.addPanel(this) // BC 12/2017 : pouvoir accéder à un panel via son id

    this.selectionListener = this.$scope.$on('t-panel-select', (event, data) => {
      this.hash.then(h => {
        this.selected = data.hash === h
      })
    });


  }

  remonterPanel() {

    var context = new Object();
    switch(this.panelid) { // variable bindée
        case 'panelbilan' :
            context.panel = 'FINANCIER';
            this.parentSimulator.$timeout(() => {this.parentSimulator.smoothScrollToPanel(context)}, 250);
            break;
        case 'panelanalyse' :
            context.panel = 'PEDAGO';
            this.parentSimulator.$timeout(() => {this.parentSimulator.smoothScrollToPanel(context)}, 250);
            break;
    }

  }

  togglePanel() {
    this.isOpen = !this.isOpen
  }

  selectPanel() {
    this.hash.then(h => this.parentPanel.selectPanel(h))
  }

/**
* affichage ou masquage du bandeau de messages "i"
*/
  doOnClickInfo() {
  this.toggleMessage()
}

toggleMessage() {
  var context = ''
  switch(this.panelid) { // variable bindée 


    case 'panelchantier' :
    context = 'CHANTIER'
    break;

    case 'panelanimation' :
    context = 'SIMULATION'
    break;

    case 'panelinstallation' :
    context = 'INSTALLATION'
    break
    
    case 'panelmouvement' :
    context = 'MOUVEMENT'
    break

    case 'panelepure' :
    context = 'EPURE'
    break

    case 'panelepurecreer' :
    context = 'CREATIONEPURE'
    break

    default :
    context = null
    break;
    }

  this.parentSimulator.toggleTerrassorMessage(context)

}

}


function hash(str) {
/*
    return (new Date().getTime() + Math.floor((Math.random()*10000)+1)).toString(16); // BC 2018/03/14 : si besoin de faire marcher IE ou EDGE
*/
  var buffer = new TextEncoder("utf-8").encode(str);


    if ((typeof(crypto) == "undefined") || (typeof(crypto.subtle) == "undefined") || (typeof(crypto.subtle.digest) == "undefined")) {

        //var crypto2 = window.crypto || window.msCrypto; // pour IE 11
        //return crypto2.subtle.digest("SHA-1", buffer).then((hash) => hex(hash));

        return("crytoPb");
    }


  return crypto.subtle.digest("SHA-1", buffer).then((hash) => hex(hash));

}

function hex(buffer) {
  var hexCodes = [];
  var view = new DataView(buffer);
  for (var i = 0; i < view.byteLength; i += 4) {
    var value = view.getUint32(i)
    var stringValue = value.toString(16)
    var padding = '00000000'
    var paddedValue = (padding + stringValue).slice(-padding.length)
    hexCodes.push(paddedValue);
  }

  return hexCodes.join("");
}



// WEBPACK FOOTER //
// ./src/client/common/uiComponents/Panel/panel.controller.js